import React, { Component } from 'react';
import { connect } from 'react-redux';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';


import { boardInfoService } from '../../services';
import { alertActions } from '../../modules/alert';

class BoardInfoAdd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            completed: 0,
            boardTypeCode: props.boardTypeCode,
            boardName: '',
            listCount: 1,
            listAuth: '',
            readAuth: '',
            writeAuth: '',
            replyAuth: '',
            replyYN: 'N',
            replyYNSwitch: false,
            open: false
        }
    }

    enterPressed = (e) => {
        let code = e.keyCode || e.which;
        if(code === 13) { //13 is the enter keycode
            this.buttonAdd.click();
        }
    }

    handleFormSubmit = (e) => {
        e.preventDefault();
        this.addBoardInfo();

        this.setState({
            boardTypeCode: '',
            boardName: '',
            listCount: 1,
            listAuth: '',
            readAuth: '',
            writeAuth: '',
            replyAuth: '',
            replyYN: 'N',
            replyYNSwitch: false,
            open: false
        });
    }

    handleValueChange = (e) => {
        let nextState = {};
        nextState[e.target.name] = e.target.value;
        this.setState(nextState);
    }

    handleSwichChange = (e) => {
        this.setState({ ...this.state, [e.target.name]: e.target.checked });
    }

    addBoardInfo = () => {
        let formData = new FormData();
        formData.append('boardTypeCode', this.state.boardTypeCode);
        formData.append('boardName', this.state.boardName);
        formData.append('listCount', this.state.listCount);
        formData.append('listAuth', this.state.listAuth);
        formData.append('readAuth', this.state.readAuth);
        formData.append('writeAuth', this.state.writeAuth);
        formData.append('replyAuth', this.state.replyAuth);
        if(this.state.replyYNSwitch)
            formData.append('replyYN', 'Y');
        else
            formData.append('replyYN', 'N');

        boardInfoService.addBoardInfo(formData)
            .then((response) => {
                console.log(response.data);
                if(response.status===200){
                    this.props.successAlerts('게시판을 추가하였습니다.');
                    this.props.stateRefresh();
                }
            })
            .catch( this.handleErrors );
    }

    handleErrors = (error) => {
        console.log(error.toString());
        if(error.response===undefined)
            this.props.errorAlerts("알 수 없는 오류가 발생하였습니다. 관리자에게 문의하시기 바랍니다.", "/home");
        else{
            if (error.response.status === 401)
                this.props.errorAlerts("권한이 없습니다.", "/login");
            else
                this.props.errorAlerts(error.response.data.message);
        }
    }

    handleClickOpen = () => {
        this.setState({
            boardTypeCode: this.props.boardTypeCode,
            boardName: '',
            listCount: 1,
            listAuth: '',
            readAuth: '',
            writeAuth: '',
            replyAuth: '',
            replyYN: 'N',
            replyYNSwitch: false,
            open: true
        })
    }

    handleClose = () => {
        this.setState({
            open: false
        });
    }

    render() {
        let listCountMenuItems = [];
        for (let i = 0; i < 50; i++) {
            listCountMenuItems.push(<MenuItem key={'list_count_'+i} value={i+1}>{i+1}</MenuItem>);
        }
        return (
            <div>
                <button className="button primary-button" onClick={this.handleClickOpen}>
                    게시판 추가
                </button>
                <Dialog open={this.state.open} onClose={this.handleClose}>
                    <DialogTitle>
                        게시판 추가
                    </DialogTitle>
                    <DialogContent>
                        <div className="form-group">
                            <InputLabel id="board-type-code-label">게시판 종류</InputLabel>
                            <Select label="board-type-code-label" name="boardTypeCode" onChange={this.handleValueChange} className="selector" value={this.state.boardTypeCode}>
                                {this.props.boardTypeCodes.map((code, i) => <MenuItem key={code.code} value={code.code}>{code.name}</MenuItem>)}
                            </Select>
                        </div>
                        <div className="form-group">
                            <InputLabel id="board-name-label">게시판명</InputLabel>
                            <TextField labelid="board-name-label" type="text" name="boardName" value={this.state.boardName} onChange={this.handleValueChange} onKeyPress={this.enterPressed} className="input-box"/><br/>
                        </div>
                        <div className="form-group">
                            <InputLabel id="list-count-label">게시물 표시 개수</InputLabel>
                            <Select labelid="list-count-label" name="listCount" onChange={this.handleValueChange} className="selector">
                                {listCountMenuItems}
                            </Select>
                        </div>
                        <div className="form-group">
                            <InputLabel id="list-auth-label">목록보기 권한</InputLabel>
                            <Select labelid="list-auth-label" name="listAuth" onChange={this.handleValueChange} className="selector">
                                {this.props.gradeList.map((grade, i) => <MenuItem key={'list_'+grade.code} value={grade.code}>{grade.name}</MenuItem>)}
                            </Select>
                        </div>
                        <div className="form-group">
                            <InputLabel id="read-auth-label">글읽기 권한</InputLabel>
                            <Select labelid="read-auth-label" name="readAuth" onChange={this.handleValueChange} className="selector">
                                {this.props.gradeList.map((grade, i) => <MenuItem key={'read_'+grade.code} value={grade.code}>{grade.name}</MenuItem>)}
                            </Select>
                        </div>
                        <div className="form-group">
                            <InputLabel id="write-auth-label">글쓰기 권한</InputLabel>
                            <Select labelid="write-auth-label" name="writeAuth" onChange={this.handleValueChange} className="selector">
                                {this.props.gradeList.map((grade, i) => <MenuItem key={'write_'+grade.code} value={grade.code}>{grade.name}</MenuItem>)}
                            </Select>
                        </div>
                        <div className="form-group">
                            <InputLabel id="reply-auth-label">댓글쓰기 권한</InputLabel>
                            <Select labelid="reply-auth-label" name="replyAuth" onChange={this.handleValueChange} className="selector">
                                {this.props.gradeList.map((grade, i) => <MenuItem key={'reply_'+grade.code} value={grade.code}>{grade.name}</MenuItem>)}
                            </Select>
                        </div>
                        <div className="form-group">
                            <InputLabel id="reply-yn-label">댓글 사용 여부</InputLabel>
                            <div>
                                <Grid component="label" container alignItems="center" spacing={1}>
                                    <Grid item>No</Grid>
                                    <Grid item>
                                        <Switch
                                            checked={this.state.replyYNSwitch}
                                            onChange={this.handleSwichChange}
                                            name="replyYNSwitch"
                                            color="primary"
                                        />
                                    </Grid>
                                    <Grid item>Yes</Grid>
                                </Grid>
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <button className="button primary-button" onClick={this.handleFormSubmit} ref={button => this.buttonAdd = button}>추가</button>
                        <button className="button outline-button" onClick={this.handleClose}>닫기</button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

function mapState(state) {
    return state;
}

const actionCreators = {
    errorAlerts: alertActions.error,
    successAlerts: alertActions.success
};

export default connect(mapState, actionCreators)(BoardInfoAdd);